const RegexValidateVin = /^[A-Z0-9]{17}$/;
// const RegexCleanVin = /[^A-Z0-9]/g;
// const RegexValidateSquishVin = /[A-Z0-9]{10}/g;

export function isPossibleVin(vin: string): boolean {
	return vin?.length === 17 && RegexValidateVin.test(vin);
}

export function cleanVin(vin: string): string {
	return vin?.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function isValidVin(vin: string): boolean {
    const cleaned = cleanVin(vin);
    return isPossibleVin(cleaned) && isPossibleManufacturerCode(cleaned);
}

// export function isValidSquishVin(squishVin: string): boolean {
// 	return squishVin?.length === 10 && /^[A-Z0-9]{10}$/.test(squishVin);
// }

// export function vinToSquishvin(vin: string): string {
// 	return isValidSquishVin(vin) ? vin : vin?.substring(0, 8) + vin?.substring(9, 11);
// }

/**
 * isPossibleManufacturerCode checks whether VIN[0:3] (WMI)
 * is structurally valid per ISO/SAE VIN character rules.
 *
 * Rules:
 * - VIN must be 17 chars
 * - Only digits + capital letters excluding I, O, Q
 * - WMI chars follow same charset rules
 * - Char 1: A–Z (except I,O,Q) OR 1–9 (no 0)
 * - Char 2: A–Z (except I,O,Q) OR 0–9
 * - Char 3: A–Z (except I,O,Q) OR 0–9 (including '9' for low-volume)
 */
export function isPossibleManufacturerCode(vin: string): boolean {
	if (typeof vin !== 'string') return false;

	vin = vin.trim().toUpperCase();
	if (vin.length !== 17) return false;

	// Validate entire VIN charset
	for (let i = 0; i < vin.length; i++) {
		if (!isAllowedVINChar(vin[i])) {
			return false;
		}
	}

	const w1 = vin[0];
	const w2 = vin[1];
	const w3 = vin[2];

	// Char 1: A–Z (excluding I,O,Q) OR 1–9
	if (!(isAllowedLetter(w1) || (w1 >= '1' && w1 <= '9'))) {
		return false;
	}

	// Char 2: A–Z (excluding I,O,Q) OR 0–9
	if (!(isAllowedLetter(w2) || (w2 >= '0' && w2 <= '9'))) {
		return false;
	}

	// Char 3: A–Z (excluding I,O,Q) OR 0–9
	if (!(isAllowedLetter(w3) || (w3 >= '0' && w3 <= '9'))) {
		return false;
	}

	return true;
}

function isAllowedVINChar(ch: string): boolean {
  return isDigit(ch) || isAllowedLetter(ch);
}

function isAllowedLetter(ch: string): boolean {
  return ch >= 'A' && ch <= 'Z' && ch !== 'I' && ch !== 'O' && ch !== 'Q';
}

function isDigit(ch: string): boolean {
  return ch >= '0' && ch <= '9';
}
